import { render, staticRenderFns } from "./LUAWorkspace.vue?vue&type=template&id=055a4fcb&scoped=true&"
import script from "./LUAWorkspace.vue?vue&type=script&lang=ts&"
export * from "./LUAWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./LUAWorkspace.vue?vue&type=style&index=0&id=055a4fcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055a4fcb",
  null
  
)

export default component.exports